import { motion } from "framer-motion";
import { Section } from "@/components/layout/Section";
import { Container } from "@/components/layout/Container";
import { staggerContainer, staggerItem } from "@/lib/animations";

const stats = [
  { value: "98%", label: "AI Accuracy Rate" },
  { value: "10K+", label: "Surveys Created" },
  { value: "500+", label: "Research Teams" },
  { value: "2M+", label: "Responses Collected" },
];

export function Stats() {
  return (
    <Section>
      <Container>
        <motion.div 
          className="grid grid-cols-2 md:grid-cols-4 gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {stats.map((stat, index) => (
            <motion.div 
              key={index} 
              className="text-center"
              variants={staggerItem}
            >
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-gradient mb-2">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-muted-foreground">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </Section>
  );
}
